const DEFAULT_BASE = 'https://ams.cdn.arkadiumhosted.com/advertisement/video/stable/';
const SCRIPT_NAME = 'video-ads.js';

export function getVideoAdsBase(): string {
  const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>(`script[src*="${SCRIPT_NAME}"]`));
  const real = scripts.find((script) => !script.src.includes('/split/')) || scripts[scripts.length - 1];
  if (!real?.src) {
    return DEFAULT_BASE;
  }
  return real.src.replace(SCRIPT_NAME, '');
}
